export const formatDtmObj = dtm => ({
  eventAction: 'click',
  eventAsset: dtm,
  eventType: 'pageInteraction'
});

export const getPageTypeVal = (pageName, segmentParams) => {
  let pageTypeVal = pageName;

  if (pageName === 'corpSegment') {
    pageTypeVal = `${pageName}-${segmentParams}`;
  }
  return pageTypeVal;
};
